export enum EmergencyCallDetailsStatus {
  CALLEE_DISCONNECTED = 'calleeDisconnected',
  CALLEE_CONNECTED = 'calleeConnected',
  CALLEE_RECONNECT = 'calleeReconnect',
  NEW_VCO_2_LINE = 'newVCO2Line',
  CHANGE_NUMBER_VCO_2_LINE = 'changeNumberVco2Line',
}
